/* A single readable column, centred on a desktop, as in the blueprint. */
.attempt {
  display: flex;
  flex-direction: column;
  gap: 18px;
  max-width: 720px;
  margin: 0 auto;
}

.top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.exit {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-height: 44px;
  color: var(--ink-2);
  font-weight: 600;
  text-decoration: none;
}

.arrow {
  width: 18px;
  height: 18px;
  background-color: currentColor;
  -webkit-mask: url('./back.svg') no-repeat center / contain;
  mask: url('./back.svg') no-repeat center / contain;
}

.saved {
  font-size: 13px;
  color: var(--ink-3);
}

.status {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.name {
  font-size: 15px;
  font-weight: 600;
  color: var(--ink-2);
}

.counter {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  color: var(--ink-2);
}

.bar {
  height: 10px;
  border: var(--outline);
  border-radius: 999px;
  background: var(--surface);
  overflow: hidden;
}

/* How far the attempt is, as a percentage the component computes. */
.fill {
  width: var(--progress);
  height: 100%;
  background: var(--accent);
}

.note {
  font-size: 13px;
  color: var(--ink-3);
  text-align: center;
}
